'use strict';

import Vue    from 'vue';
import Vuex   from 'vuex';
Vue.use(Vuex);
// This fixes devtools not picking up store
Vue.config.devtools = true;

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import messages     from './modules/messages';
import poolForm     from './modules/pool-form';
import paymentModal from './modules/payment-modal';
import poolArchives from './modules/pool-archives';
import comments     from './modules/comments';
import poolParticipationOffers from './modules/pool-participation-offers';
import poolStats    from './modules/pool-stats';

export default new Vuex.Store({
  modules: {
    messages,
    poolForm,
    poolArchives,
    comments,
    paymentModal,
    poolParticipationOffers,
    poolStats
  },
  state: {
    currentUser:                localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null,
    participationVerification:  localStorage.getItem('participationVerification') || null,
    dashboardPools:             {updatedAt: null, pools: []},
    pools:                      [],
    navigation:                 {},
    participationsAwaitingUser: []
  },
  actions,
  getters,
  mutations
});
